
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sponsored",
      function () {
        return require("private-next-pages/sponsored/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sponsored"])
      });
    }
  